<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: start;
        align-items: center;
      ">
      <div class="col">
        <h4>
          Datos del cliente
        </h4>
      </div>
      <div class="col">
        <h4></h4>
      </div>
    </div>

    <form autocomplete="off" [formGroup]="formHeader">
      <div class="filtros-body">
        <div class="row">
          <!-- Datos del cliente -->
          <div class="col">
            <div class="row">
              <div class="col dato" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" type="text" id="nroDoc" class="form-control" placeholder="000" required #nroDoc
                    formControlName="nroDoc" />
                  <label for="nroDoc">Nro. Doc.</label>
                </div>
              </div>
              <div class="col dato">
                <Strong class="title">Factura asociada</Strong>
                <span class="value">#999999</span>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col" style="max-width: 300px;">
                <div class="md-form m-0">
                  <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Doc.'" required
                    formControlName="fechaDoc">
                  </mdb-date-picker>
                </div>
              </div>
              <div class="col" style="max-width: 300px;">
                <div class="md-form m-0">
                  <mdb-date-picker [inline]="true" name="fechaVenc" [placeholder]="'Fecha Venc.'" required
                    formControlName="fechaVencimiento">
                  </mdb-date-picker>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 300px;">
                <div class="md-form m-0">
                  <mdb-select label="Bodega" [options]="optionsBodega" placeholder="Seleccionar Bodega"
                    [filterEnabled]="true" formControlName="bodega"></mdb-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" type="text" id="rutCliente" class="form-control" placeholder="9.999.999-9" required
                    formControlName="rutCliente" formatRut #rutCliente />
                  <label for="rutCliente">RUT del cliente</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col dato">
                <Strong class="title">Dirección</Strong>
                <span class="value">Santa victoria 41</span>
              </div>
              <div class="col dato">
                <Strong class="title">Comuna</Strong>
                <span class="value">Santiago</span>
              </div>
              <div class="col dato">
                <Strong class="title">Provincia</Strong>
                <span class="value">Santiago</span>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar Sucursal"
                    formControlName="sucursal" [filterEnabled]="true"></mdb-select>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="dire" class="form-control" placeholder="Dirección" required #dire />
                  <label for="dire">Dirección</label>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="comuna" class="form-control" placeholder="Comuna" required #comuna />
                  <label for="comuna">Comuna</label>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="provincia" class="form-control" placeholder="Provincia" required
                    #provincia />
                  <label for="provincia">Provincia</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col dato" style="max-width: 150px;">
                <Strong class="title">Cond. Pago</Strong>
                <span class="value">
                  <mdb-badge pill="true" success="true">Contado</mdb-badge>
                </span>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" type="text" id="oc" class="form-control" placeholder="OC" required #oc
                    formControlName="oc" />
                  <label for="oc">OC</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" type="text" id="descuento" class="form-control" placeholder="% Descuento" required
                    formControlName="porcentajeDescuento" />
                  <label for="descuento">% Descuento</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FIN/ FILA #2 -->
      </div>
    </form>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row">
      {{formHeader.value | json}}
    </div>
  </div>
</div>
